var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C4C4C4;}\r\n\t.st1{fill:#616160;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#C4C4C4;stroke:#616160;stroke-miterlimit:10;}\r\n\t.st4{fill:#FFFFFF;stroke:#616160;stroke-miterlimit:10;}\r\n\t.st5{fill:#616160;stroke:#616160;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#616160;stroke-miterlimit:10;stroke-dasharray:2.0068,2.0068;}\r\n\t.st7{fill:#616160;stroke:#616160;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st9{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st10{fill:#C4C4C4;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st11{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;stroke-dasharray:1.9724,1.9724;}\r\n\t.st12{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st13{fill:#F15A24;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10.419,12.503H4.46c-1.105,0-2-0.895-2-2V4.545c0-1.105,0.895-2,2-2h5.958c1.105,0,2,0.895,2,2v5.958 C12.419,11.608,11.523,12.503,10.419,12.503z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M13.463,9.832L13.45,9.845c-0.178,0.178-0.252,0.416-0.232,0.648l-0.347-0.347 c-0.318-0.318-0.834-0.318-1.152,0l-0.013,0.013c-0.182,0.182-0.332,0.351-0.306,0.588c-0.32-0.249-0.891-0.341-1.185-0.047 l-0.013,0.013c-0.178,0.178-0.252,0.416-0.232,0.648l-0.999-0.999c-0.318-0.318-0.834-0.318-1.152,0l-0.013,0.013 c-0.318,0.318-0.318,0.834,0,1.152c0.876,0.876,1.752,1.752,2.628,2.628c0.176,0.176,0.351,0.351,0.527,0.527 c-0.228-0.061-0.456-0.122-0.684-0.183c-0.434-0.116-0.881,0.141-0.998,0.576l-0.005,0.018c-0.116,0.435,0.141,0.881,0.576,0.998 c1.682,0.455,3.365,0.91,5.047,1.365l2.64-2.64c-0.155-0.723-0.475-1.799-1.178-2.95c-0.737-1.205-1.155-1.563-1.746-2.033 C14.297,9.514,13.781,9.514,13.463,9.832z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 9.971,
    y1: 11.362,
    x2: 11.774,
    y2: 13.165
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 11.289,
    y1: 10.636,
    x2: 13.116,
    y2: 12.464
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 12.684,
    y1: 9.959,
    x2: 14.414,
    y2: 11.69
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnClick);
export default __webpack_public_path__ + "static/media/_OnClick.b27121da4de147ab30d32fb6e4840bf2.svg";
export { ForwardRef as ReactComponent };